export const LOAD_DOCUMENT_SIGNEES_STARTED = "LOAD_DOCUMENT_SIGNEES_STARTED";
export const LOAD_DOCUMENT_SIGNEES_SUCCEEDED = "LOAD_DOCUMENT_SIGNEES_SUCCEEDED";
export const LOAD_DOCUMENT_PERSONS_STARTED = "LOAD_DOCUMENT_PERSONS_STARTED";
export const LOAD_DOCUMENT_PERSONS_SUCCEEDED = "LOAD_DOCUMENT_PERSONS_SUCCEEDED";
export const LOAD_DOC_ENTITIES_STARTED = "LOAD_DOC_ENTITIES_STARTED";
export const LOAD_DOC_ENTITIES_SUCCEEDED = "LOAD_DOC_ENTITIES_SUCCEEDED";
export const LOAD_GUARANTORS_STARTED = "LOAD_GUARANTORS_STARTED";
export const LOAD_GUARANTORS_SUCCEEDED = "LOAD_GUARANTORS_SUCCEEDED";


export const SAVE_DOCUMENT_SIGNEES_STARTED = "SAVE_DOCUMENT_SIGNEES_STARTED";
export const SAVE_DOCUMENT_SIGNEES_FINISHED = "SAVE_DOCUMENT_SIGNEES_FINISHED";
export const DOCUMENT_SIGNEES_UPDATED = "DOCUMENT_SIGNEES_UPDATED";
